import * as React from 'react';
import {useLanguagesQuery} from "../../../../types.d";
import {Link, NavLink} from "react-router-dom";
import {Route, RouteComponentProps, Switch} from "react-router";
import {LanguageOverview} from "./LanguageOverview";
import {ProgressAchievementEdit} from "./ProgressAchievementEdit";
import {LanguagesSidebar} from "../../../partials/LanguagesSidebar";

interface LanguagesPageProps extends RouteComponentProps {

}

export const LanguagesPage = (props: LanguagesPageProps) => {
    const { match } = props;

    const languages = useLanguagesQuery();

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Languages
                    </li>
                </ol>
            </nav>

            <div className={'row pt-3'}>
                { languages.data && (
                    <LanguagesSidebar
                        basePath={match.path}
                        languages={languages.data.languages} />
                ) }

                <div className={'col col-9'}>
                    <Switch>
                        <Route path={`${match.path}/:language/modal/:id`} component={ProgressAchievementEdit} />
                        <Route path={`${match.path}/:language`} component={LanguageOverview} />
                    </Switch>
                </div>
            </div>
        </div>
    </div>
};
